import React, { useEffect, useRef, useState } from 'react';
import './Service.css';
import aboutImage from '../image/service.png';
import cloud1 from '../image/cloud1.png';
import cloud2 from '../image/cloud2.png';
import cloud3 from '../image/cloud3.png';
import cloud4 from '../image/cloud4.png';
import CountUp from 'react-countup';

const services = [
  {
    icon: '📱',
    title: 'Mobile Applications',
    description: 'We design and develop high-performance mobile applications that deliver seamless user experiences across Android and iOS platforms',
    bg: '#fce9fb',
  },
  {
    icon: '🛡️',
    title: 'Cyber Security',
    description: 'Protect your business with advanced cybersecurity solutions ensuring data security, threat prevention, and system reliability',
    bg: '#ffeceb',
  },
  {
    icon: '🚀',
    title: 'Software Development',
    description: 'We build scalable, secure, and high-performance software solutions tailored to accelerate your business growth',
    bg: '#e7f4fe',
  },
  {
    icon: '🌐',
    title: 'Digital Transformation',
    description: 'Transform your business with innovative digital solutions that enhance efficiency, productivity, and customer experience',
    bg: '#f5e5fc',
  },

  {
    icon: '☁️',
    title: 'Full Stack - Cloud Based Services',
    description: 'End-to-end full stack development combined with scalable cloud infrastructure for modern, secure, and reliable applications',
    bg: '#e8f9ff',
  },
  {
    icon: '🏥',
    title: 'Health Care Services',
    description: 'Delivering smart healthcare software solutions including patient management, digital records, and telemedicine platforms',
    bg: '#ffeef3',
  },
  {
    icon: '🗺️',
    title: 'Google Mapping (GIS) Services',
    description: 'Advanced GIS and Google Maps integration to build intelligent location-based applications and data-driven solutions',
    bg: '#e9ffe8',
  },
];

const service0 = [
  {
    image: cloud1,
    title: 'AI-Powered Assessments',
    description:
      'Evaluate your skills with adaptive AI tests based on real-world problems.',
  },
  {
    image: cloud2,
    title: 'Mock Interviews',
    description:
      'Simulate real interviews with expert feedback to boost your confidence.',
  },
  {
    image: cloud3,
    title: 'Live Workshops',
    description:
      'Participate in interactive sessions guided by top industry mentors.',
  },
  {
    image: cloud4,
    title: 'Certifications',
    description:
      'Earn recognized certifications that enhance your professional credibility.',
  },
];

const duplicatedServices = [...service0, ...service0];

const Service = () => {
  const statsRef = useRef(null);
  const [startCount, setStartCount] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (!startCount && statsRef.current) {
        const top = statsRef.current.getBoundingClientRect().top;
        if (top < window.innerHeight - 100) {
          setStartCount(true);
        }
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [startCount]);

  return (
    <div>

      {/* Services Section */}
      <section className="services-wrapper">
        <div className="services-header">
          <div className="header-icon">📣</div>
          <h2>
            Our <span>Services</span>
          </h2>
          <p>
            We specialize in bridging the gap between talent and industry by offering expert-led
            training, real-world project experience, and end-to-end career support to help
            individuals and organizations achieve their full potential.
          </p>
        </div>

        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-box">
              <div className="icon-circle" style={{ backgroundColor: service.bg }}>
                {service.icon}
              </div>

              <div className="text-block">
                <h3>{service.title}</h3>
                <p>{service.description}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* About Section */}
      <section className="about-section">
        <div className="about-text">
          <p>
            Our consultancy arm partners with organizations to bridge skill gaps through customized
            training solutions. We help companies upskill their teams, integrate modern tools, and
            improve productivity through strategic learning programs.
          </p>

          <p>
            Track your learning journey through intuitive dashboards and earn verified certificates
            after course completion. Showcase your expertise to potential employers and build a
            credible portfolio.
          </p>

          <button className="about-button">Contact us</button>
        </div>

        <div className="about-image">
          <img src={aboutImage} alt="3D Illustration" />
        </div>
      </section>

      {/* Latest Services */}
      <section className="latest-services">
        <h2>Our Latest Services</h2>

        <div className="scroll-wrapper">
          <div className="auto-scroll-track">
            {duplicatedServices.map((service, index) => (
              <div key={index} className="service-card">
                <img src={service.image} alt="service" />
                <h3>{service.title}</h3>
                <p>{service.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Subscribe */}
      <section className="subscribe-section">
        <h2>Talent Trek Technologies</h2>

        <div className="subscribe-form">
          <input type="email" placeholder="Enter your email" />
          <button>LOGIN</button>
        </div>
      </section>

    </div>
  );
};

export default Service;